import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-issuers',
  templateUrl: './issuers.component.html',
  styleUrls: ['./issuers.component.css']
})
export class IssuersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/users/issuers/issuers.component.ts